const convertDate = (date) => {
  if (!date) return "-"

  let date2 = new Date(date).toDateString();

  return date2;
}

let getDmY = () => {
  let date = new Date();
  return date.getDate() + "" + date.getMonth() + "" + date.getFullYear() + "_" + date.getHours() + "" + date.getMinutes();
};

export {
  convertDate, getDmY
}